import * as actions from '../redux/actions';
import * as cuponeraActions from '../../cuponera/redux/actions';

import React, { useEffect } from 'react';

import HomeBanners from '../HomeBanners';
// import HeroSection from '../common/HeroSection/HeroSection';
// import getIcons from '../functions/getIcons/getIcons';
import ThemeEightSearchBox from './common/ThemeEightSearchBox';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getSlides from '../functions/getSlides/getSlides';

const ThemeEight = ({ history, operator, actions }) => {
  useEffect(() => {
    // Clean up cuponera session storage data
    sessionStorage.removeItem('cuponeraSourceCity');
    sessionStorage.removeItem('cuponeraDestinationCity');
    sessionStorage.removeItem('cuponeraSeats');
    sessionStorage.removeItem('selectedCuponera');
    actions.setCuponeraSeats({});
    actions.setSelectCuponera(null);
  }, []);

  return (
    <div className="theme-eight">
      <div style={{ position: 'relative' }}>
        {/* <HeroSection height={'100vh'} heroImage={getIcons('Banner', operator)} /> */}

        <HomeBanners slides={getSlides('Banner', operator)} height={'90vh'} activeDotColor="#fff" />

        <div className="searchboxoverlay">
          <div className="new-container">
            <ThemeEightSearchBox history={history} operator={operator} />
          </div>
        </div>
      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...cuponeraActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeEight);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeEight/ThemeEight.js